const env=process.env.NODE_ENV;
const requestUrl = {
    test:'http://http://192.168.8.140:9999/',
    development:'http://http://192.168.8.140:9999/', //config/index.js配置代理
    // development:'http://47.106.133.194:8083/',
    production:'http://47.106.133.194:8083/'
}

export default requestUrl[env]


// WEBPACK FOOTER //
// ./src/config/baseUrl.js